import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../client";
import { useMe } from "./useMe";
import type { TrashEntry } from "../types";

/** The caller's soft-deleted workspaces (owner-scoped, keyed by user, not slug). */
export const TRASH_WORKSPACES_KEY = ["trash", "workspaces"] as const;

export function trashReposKey(slug: string) {
  return ["trash", "repos", slug] as const;
}

export function useTrashWorkspaces(): UseQueryResult<TrashEntry[], ApiError> {
  const me = useMe();
  return useQuery<TrashEntry[], ApiError>({
    queryKey: TRASH_WORKSPACES_KEY,
    queryFn: ({ signal }) => apiFetch<TrashEntry[]>("/api/me/trash/workspaces", { signal }),
    enabled: !!me.data,
  });
}

export function useTrashRepos(slug: string): UseQueryResult<TrashEntry[], ApiError> {
  return useQuery<TrashEntry[], ApiError>({
    queryKey: trashReposKey(slug),
    queryFn: ({ signal }) => apiFetch<TrashEntry[]>(`/api/ws/${slug}/trash/repos`, { signal }),
    enabled: !!slug,
  });
}
